import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import withProductWishlistMutations from "../AddProductToWishlist/withProductWishlistMutations";
import branchServerClient from "web/core/branchServerClient";

export default () =>
  compose(
    branchServerClient(
      () => () => null,
      (BaseComponent) => BaseComponent
    ),
    withProps((props) => ({
      isInWishlist: true,
      sku: props.wishlistItem.product.sku,
    })),
    withHandlers({
      onAddDone: (props) => () => {
        typeof props.onAddDone === "function" && props.onAddDone();
      },
    }),
    withHandlers({
      onSuccess: (props) => () => props.onAddDone(),
      onError: (props) => () => props.onAddDone(),
    }),
    withProductWishlistMutations()
  );
